import * as React from "react";
import { Collapse, Slider, Input, Switch } from "antd";
import styled from "styled-components";
import { ChromePicker } from "react-color";
import update from "immutability-helper";
import { ThemeContext } from "../../../../themeDesigner";

const Panel = Collapse.Panel;

const Label = styled.label`
  font-family: Muli;
  font-size: 13px;
  font-weight: 600;
  color: #7f90af;
  display: block;
  margin-bottom: 8px;
`;

const SettingRow = styled.div`
  margin-bottom: 16px;
`;

const ColorPickerWrapper = styled.div`
  margin-bottom: 8px;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  input {
    flex: 1;
  }
`;

export default function InputProperties() {
  const { themeProps, setThemeProps } = React.useContext(ThemeContext);
  const inputStyles = themeProps.widget.modernUIStyles.input;

  const handleUpdate = (key: string, value: any) => {
    const numValue = typeof value === "number" ? value : (Array.isArray(value) ? value[0] : value);
    const updated = update(themeProps, {
      widget: {
        modernUIStyles: {
          input: {
            [key]: { $set: numValue },
          },
        },
      },
    });
    setThemeProps(updated);
  };

  return (
    <Collapse defaultActiveKey={["1"]}>
      <Panel header="Input Field Styles" key="1">
        <SettingRow>
          <Label>Border Radius (px)</Label>
          <Wrapper>
            <Input
              type="number"
              value={inputStyles.borderRadius}
              onChange={(e) =>
                handleUpdate("borderRadius", parseInt(e.target.value) || 24)
              }
              min={0}
              max={50}
            />
            <span>{inputStyles.borderRadius}px</span>
          </Wrapper>
          <Slider
            value={inputStyles.borderRadius}
            onChange={(val) => handleUpdate("borderRadius", val)}
            min={0}
            max={50}
            step={1}
            style={{ marginTop: "8px" }}
          />
        </SettingRow>

        <SettingRow>
          <Label>Shadow Blur (px)</Label>
          <Wrapper>
            <Input
              type="number"
              value={inputStyles.shadowBlur}
              onChange={(e) => handleUpdate("shadowBlur", parseInt(e.target.value) || 8)}
              min={0}
              max={50}
            />
            <span>{inputStyles.shadowBlur}px</span>
          </Wrapper>
          <Slider
            value={inputStyles.shadowBlur}
            onChange={(val) => handleUpdate("shadowBlur", val)}
            min={0}
            max={50}
            step={1}
            style={{ marginTop: "8px" }}
          />
        </SettingRow>

        <SettingRow>
          <Label>Shadow Color</Label>
          <ColorPickerWrapper>
            <ChromePicker
              color={{
                r: inputStyles.shadowColor.r,
                g: inputStyles.shadowColor.g,
                b: inputStyles.shadowColor.b,
                a: inputStyles.shadowColor.a,
              }}
              onChangeComplete={(color) => {
                handleUpdate("shadowColor", {
                  r: color.rgb.r,
                  g: color.rgb.g,
                  b: color.rgb.b,
                  a: color.rgb.a,
                });
              }}
            />
          </ColorPickerWrapper>
        </SettingRow>

        <SettingRow>
          <Label>Enable Glassmorphism</Label>
          <Switch
            checked={inputStyles.enableGlassmorphism}
            onChange={(checked) => handleUpdate("enableGlassmorphism", checked)}
          />
        </SettingRow>

        {inputStyles.enableGlassmorphism && (
          <SettingRow>
            <Label>Backdrop Blur (px)</Label>
            <Wrapper>
              <Input
                type="number"
                value={inputStyles.backdropBlur}
                onChange={(e) =>
                  handleUpdate("backdropBlur", parseInt(e.target.value) || 10)
                }
                min={0}
                max={50}
              />
              <span>{inputStyles.backdropBlur}px</span>
            </Wrapper>
            <Slider
              value={inputStyles.backdropBlur}
              onChange={(val) => handleUpdate("backdropBlur", val)}
              min={0}
              max={50}
              step={1}
              style={{ marginTop: "8px" }}
            />
          </SettingRow>
        )}
      </Panel>
    </Collapse>
  );
}
